import React from "react";
import ESIPage from "@/components/esi-page/ESIPage";

function generateMetadata() {
  return {
    title: "How to return your item",
    description: `Have a question? We're here to help with all your queries, from delivery and returns to orders and your online account and your My John Lewis membership.`,
  };
}

function Page() {
  return <ESIPage />;
}

Page.generateMetadata = generateMetadata;

export default Page;
